module.exports = __webpack_public_path__ + "img/2021-Chevrolet-Blazer-008.e9ad6317.jpg";